/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputSiblingZoneChannelData
 */
export interface OutputSiblingZoneChannelData {
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingZoneChannelData
     */
    band?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingZoneChannelData
     */
    band2?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingZoneChannelData
     */
    channel?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingZoneChannelData
     */
    channel2?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputSiblingZoneChannelData
     */
    freq?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputSiblingZoneChannelData
     */
    freq2?: number;
}

/**
 * Check if a given object implements the OutputSiblingZoneChannelData interface.
 */
export function instanceOfOutputSiblingZoneChannelData(value: object): boolean {
    return true;
}

export function OutputSiblingZoneChannelDataFromJSON(json: any): OutputSiblingZoneChannelData {
    return OutputSiblingZoneChannelDataFromJSONTyped(json, false);
}

export function OutputSiblingZoneChannelDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSiblingZoneChannelData {
    if (json == null) {
        return json;
    }
    return {
        
        'band': json['band'] == null ? undefined : json['band'],
        'band2': json['band2'] == null ? undefined : json['band2'],
        'channel': json['channel'] == null ? undefined : json['channel'],
        'channel2': json['channel2'] == null ? undefined : json['channel2'],
        'freq': json['freq'] == null ? undefined : json['freq'],
        'freq2': json['freq2'] == null ? undefined : json['freq2'],
    };
}

export function OutputSiblingZoneChannelDataToJSON(value?: OutputSiblingZoneChannelData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'band': value['band'],
        'band2': value['band2'],
        'channel': value['channel'],
        'channel2': value['channel2'],
        'freq': value['freq'],
        'freq2': value['freq2'],
    };
}

